/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ImageShapeEnum = "circle" | "container" | "shipment" | "square" | "vessel" | "voyage" | "%future added value";
export type ExternalFeedImages_data = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly url: string | null;
            readonly shape: ImageShapeEnum | null;
            readonly overlay: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "ExternalFeedImages_data";
};
export type ExternalFeedImages_data$data = ExternalFeedImages_data;
export type ExternalFeedImages_data$key = {
    readonly " $data"?: ExternalFeedImages_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalFeedImages_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalFeedImages_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shape",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overlay",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ImageConnection",
  "abstractKey": null
};
(node as any).hash = 'e1e66d999a566ff62eae5f2d6203a592';
export default node;
